// extracted by mini-css-extract-plugin
export default {"container":"staffEditor_container__wAaP-"};